import ProductDescription from './ProductDescription'

const YogurtProduct = {
  ...ProductDescription,
  category: '50',
  subCategory: '',
  IsBroadband: false,
  VitaminD: '',
  Sugar: '',
  SugarCertification: false,
  SweetenerCertification: false,
  FatLevel: '',
  Flavor: '',
  OtherFlavor: null,
  Size: '32 ounces only',
  MultiPackageType: false,
  MultiPackageCount: null,
}

export default YogurtProduct
